import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoinRupees: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCoinRupees"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM9 7V8.5H11.75C12.7293 8.5 13.56 9.12657 13.8691 10H7V11.5H13.8691C13.56 12.3734 12.7293 13 11.75 13H9V14.418L14.4375 17.7822L15.2266 16.5068L11.9717 14.4922C13.6863 14.3922 15.0905 13.141 15.4238 11.5H17V10H15.4248C15.0773 8.28834 13.5642 7 11.75 7H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCoinRupees;
